import { store } from '../../index'

export const UPDATE_USER_STATUS = 'UPDATE_USER_STATUS'

export const updateUserStatus = function (status) {
  store.dispatch({
    type: UPDATE_USER_STATUS,
    status
  })
}



// WEBPACK FOOTER //
// ./src/redux/actions/update-user-status.js